import {
  Checkbox,
  DatePicker,
  Icon,
  SearchBar,
  SearchDataProps,
  Section,
  useToast,
} from '@vallourec-ui/vallourec-ui'
import React, { useEffect, useRef, useState } from 'react'

import { useTranslation } from 'react-i18next'

import moment from 'moment'

import { isAxiosError } from 'axios'

import { useLocation } from 'react-router-dom'

import { useSearchReport } from '@/stores/SearchReportStore'

import {
  ButtonContainer,
  CheckboxContainer,
  Row,
  SearchBarContainer,
  StyledButton,
  StyledInputLabel,
  StyledTextButton,
} from './style'
import { SITES, TESTS } from '@/utils/constants'

import { InsterpectorTypeEnum, SampleTypeEnum } from '@/@types/enums'
import { DataResultTemplate, OrderItemFilter } from '@/@types/global'
import { document as documentPost, reportFilter } from '@/api/post'
import TextFieldInput from '@/components/TextFieldInput'
import { generateObject } from '@/report/generateTest'
import { useApp } from '@/stores/AppStore'
import {
  addOptionAll,
  downloadBase64,
  downloadFile,
  extractFileNameByPath,
  getFilesByPaths,
} from '@/utils/utils'

const FilterSection: React.FC = () => {
  const { t } = useTranslation()
  const { toast } = useToast()
  const location = useLocation()
  const dataState = location.state
  const originApprovalFlow = dataState?.docCode

  const rowFocus = useRef<HTMLInputElement>(null)
  const {
    setIsLoading,
    setTemplateColumn,
    setTemplateRow,
    setResultItems,
    executeSearch,
    setExecuteSearch,
    startDateApprovalFlow,
    setStartDateApprovalFlow,
    endDateApprovalFlow,
    setEndDateApprovalFlow,
    processOrderItemsApprovalFlow,
    setProcessOrderItemsApprovalFlow,
    user,
  } = useApp()
  const {
    site,
    setSite,
    test,
    setTest,
    mappedSites,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    project,
    setProject,
    orderItem,
    setOrderItem,
    typeInspection,
    setTypeInspection,
    type,
    setType,
    testSelected,
    setTestSelected,
    heatItems,
    setHeatItems,
    processOrderItems,
    setProcessOrderItems,
    setTemplateTest,
    identificationApprovalFlow,
    setIdentificationApprovalFlow,
  } = useSearchReport()

  const [identification, setIdentification] = useState('')
  const [idNumeric, setIdNumeric] = useState('')
  const [active, setActive] = useState(true)
  const [inactive, setInactive] = useState(false)
  const [orderItemFilter, setOrderItemFilter] =
    React.useState<OrderItemFilter>()
  const [labelProject, setLabelProject] = React.useState('')
  const [mappedTestsFilter, setMappedTestsFilter] = React.useState<
    SearchDataProps[]
  >([])
  const [siteCode, setSiteCode] = React.useState<string>('')
  const [mapPqLot, setMapPqLot] = React.useState<SearchDataProps[]>([])
  const [mapProcessOrder, setMapProcessOrder] = React.useState<
    SearchDataProps[]
  >([])
  const [
    multiselectInputValueProcessOrder,
    setMultiselectInputValueProcessOrder,
  ] = React.useState<string[]>([])
  const [mapHeat, setMapHeat] = React.useState<SearchDataProps[]>([])
  const [mapProjects, setMapProjects] = React.useState<SearchDataProps[]>([])
  const [pqLotItems, setPqLotItems] = React.useState<string[] | null>(null)
  const [typeItems, setTypeItems] = React.useState<string[] | null>(null)
  const [mapPedidoItem, setMapPedidoItem] = React.useState<SearchDataProps[]>(
    []
  )
  const [selectAllProcessOrder, setSelectAllProcessOrder] =
    React.useState(false)
  const mapType = addOptionAll(
    Object.values(InsterpectorTypeEnum).map((elem, index) => {
      return {
        key: index + 1,
        value: t(elem),
        label: t(elem),
      }
    })
  )
  const mapInsterpectorType = addOptionAll(
    Object.values(SampleTypeEnum).map((elem, index) => {
      return {
        key: index + 1,
        value: t(elem),
        label: t(elem),
      }
    })
  )

  useEffect(() => {
    if (siteCode) {
      setMappedTestsFilter(
        TESTS.filter((s) => s.sites.includes(siteCode))
          .map((s) => ({
            key: s.key,
            value: s.id?.toString() || '',
            label: t(`report.id.${s.id}`),
          }))
          .sort((a, b) => a.label.localeCompare(b.label))
      )
    }
  }, [siteCode])

  const clearProcessOrder = () => {
    setMapProcessOrder([])
    if (!originApprovalFlow) setProcessOrderItems(undefined)
    clearResults()
  }

  const findProjectsQp = async () => {
    try {
      setIsLoading(true)
      if (startDate && endDate && testSelected) {
        const result = await reportFilter({
          filterType: false,
          test: testSelected,
          filter: testSelected.type === 4 ? 'QP_CORROSIVE' : 'PROJECT',
          site: siteCode,
          start: moment(startDate).startOf('day').format('YYYY/MM/DD HH:mm:ss'),
          end: moment(endDate).endOf('day').format('YYYY/MM/DD HH:mm:ss'),
        })

        if (testSelected.type === 4) {
          const listItems = result?.list?.map(
            (s: { lot_id: any; ordem_de_processo: any }, index: number) => ({
              key: index + 1,
              value: s.lot_id || s.ordem_de_processo || '',
              label: s.lot_id || s.ordem_de_processo,
            })
          )
          setMapPqLot(listItems)
          if (identificationApprovalFlow) {
            setPqLotItems(
              Array.isArray(dataState.filter_header.pq)
                ? dataState.filter_header.pq
                : [dataState.filter_header.pq]
            )
          }
        } else {
          const listPorjects = addOptionAll(
            result?.list?.map((s: { desc_projeto: string }, index: number) => ({
              key: index + 1,
              value: s.desc_projeto || '',
              label: s.desc_projeto,
            }))
          )
          setMapProjects(listPorjects)
          if (identificationApprovalFlow) {
            setLabelProject(
              listPorjects.find(
                (s) =>
                  s.value ===
                  (dataState.filter_header.project ??
                    dataState.filter_header.projectChange)
              )?.label
            )
            setProject(
              listPorjects.find(
                (s) => s.value === dataState.filter_header.project
              )?.value
            )
          }
        }
      } else if (identificationApprovalFlow) {
        setIsLoading(false)
      }
    } catch (error: unknown) {
      if (isAxiosError(error)) {
        toast({
          title: 'Error',
          description: error.response?.data?.errorMessage ?? error.message,
          type: 'error',
        })
      }
    } finally {
      if (!identificationApprovalFlow) setIsLoading(false)
    }
  }

  const clearTest = (value: string) => {
    setTest('')
    value && setSiteCode(SITES.find((s) => s.name === value)?.code ?? '')
    // clearDate()
    clearResults()
  }

  const clearDate = () => {
    setStartDate(undefined)
    setEndDate(undefined)
    clearProject()
    clearPQ()
    clearResults()
  }

  const clearOrderItem = () => {
    setOrderItem('')
    setOrderItemFilter(undefined)
    clearProcessOrder()
  }

  const clearProject = () => {
    setProject('')
    setMapProjects([])
    clearPedidoItem()
    clearResults()
  }

  const clearPQ = () => {
    setMapPqLot([])
    setPqLotItems(null)
    clearResults()
  }

  const clearHeat = () => {
    setMapHeat([])
    setHeatItems(undefined)
    clearResults()
  }

  const changeType = (value: string[]) => {
    setTypeItems(value.length > 0 ? value : null)
  }

  useEffect(() => {
    if (!startDate && !endDate && !site && !test && testSelected?.type === 4) {
      findProjectsQp()
    } else if (orderItem && testSelected?.type !== 4) {
      findProcessOrder()
    }
  }, [typeItems])

  const changePQ = (value: string[]) => {
    setPqLotItems(value.length > 0 ? value : null)
  }

  const changeProcessOrder = (value: string[]) => {
    setProcessOrderItems(value.length > 0 ? value : undefined)
    clearResults()
  }

  const changeHeat = (value: string[]) => {
    setHeatItems(value.length > 0 ? value : undefined)
  }

  const clearPedidoItem = () => {
    setMapPedidoItem([])
    setOrderItem('')
    setOrderItemFilter(undefined)
    clearOrderItem()
    clearHeat()
  }

  const search = async () => {
    try {
      setIsLoading(true)
      await executeQuery()
    } catch (error) {
      console.log('error', error)
    } finally {
      setIsLoading(false)
    }
  }

  const validate = () => {
    let valid = true
    if (
      (!identification || identification.trim().length === 0) &&
      (!idNumeric || idNumeric.trim().length === 0) &&
      (!startDate || !endDate || !site || !test || !project) &&
      testSelected?.type !== 4
    ) {
      toast({
        title: 'Error',
        description: t('generateReport.filterSection.required_filter'),
        type: 'error',
      })
      valid = false
    }
    if (
      (!identification || identification.trim().length === 0) &&
      (!idNumeric || idNumeric.trim().length === 0) &&
      (!startDate ||
        !endDate ||
        !site ||
        !test ||
        !pqLotItems ||
        pqLotItems.length === 0) &&
      testSelected?.type === 4
    ) {
      toast({
        title: 'Error',
        description: t('generateReport.filterSection.required_filter_pq'),
        type: 'error',
      })
      valid = false
    }
    if (!user || !user.userPosition) {
      toast({
        title: 'Error',
        description: t('user.not_position'),
        type: 'error',
      })
      valid = false
    }
    return valid
  }

  const downloadReport = async (id: number, path_file?: string) => {
    try {
      setIsLoading(true)
      if (path_file) {
        const { file } = await getFilesByPaths({ pathPdf: path_file })

        downloadFile(file, extractFileNameByPath(path_file))
      } else {
        const result = await documentPost({ download: id })
        downloadBase64(
          document,
          result.report.name,
          result.report.report,
          atob(result.report.report)
        )
      }
    } catch (error) {
      console.log(error)
      if (isAxiosError(error)) {
        toast({
          title: 'Error',
          description: error.response?.data?.errorMessage ?? error.message,
          type: 'error',
        })
      } else {
        toast({
          title: 'Error',
          description: `${error}`,
          type: 'error',
        })
      }
    } finally {
      setIsLoading(false)
    }
  }

  const getSampleType = () => {
    const sample = []
    if (typeItems && typeItems.length > 0) {
      if (typeItems.includes('***')) return null

      if (typeItems.includes('Produção') || typeItems.includes('Production'))
        sample.push('PRODUCTION')
      if (typeItems.includes('MPQT')) sample.push('MPQT')
      if (typeItems.includes('FDPT')) sample.push('FDPT')
      if (typeItems.includes('PD') || typeItems.includes('P&D'))
        sample.push('PD')
    }
    return sample.length > 0 ? sample : undefined
  }

  const executeQuery = async () => {
    if (validate() && user && user.userPosition) {
      try {
        setIsLoading(true)
        const result = await documentPost({
          search: true,
          orderProcess: processOrderItems ?? null,
          orderItem: orderItemFilter
            ? {
                order_item: `${orderItemFilter.pedido}/${orderItemFilter.item}`,
              }
            : undefined,
          project,
          heat: heatItems,
          pqLot: pqLotItems,
          active,
          inactive,
          start: startDate
            ? moment(startDate).startOf('day').format('YYYY/MM/DD HH:mm:ss')
            : undefined,
          end: endDate
            ? moment(endDate).endOf('day').format('YYYY/MM/DD HH:mm:ss')
            : undefined,
          identification,
          idNumeric,
          ...(getSampleType() !== undefined
            ? { sampleType: getSampleType() }
            : {}),
          test: testSelected,
        })

        const template = generateObject('searchReport')
        setTemplateTest(template)

        const res: { columns: DataResultTemplate[]; row: any[] } = {
          columns: [],
          row: [],
        }
        if (template) {
          res.columns = template.map((elem) => {
            return {
              id: elem.id,
              accessorKey: elem.id,
              header: t(elem.header),
              width: elem.width,
              cell: ({ cell }) => {
                return <div>{cell.getValue()}</div>
              },
            } as DataResultTemplate
          })
          res.row = result.items.map((item: any, index: number) => {
            item.checked = item.document_version === undefined
            const objectRow = {
              ...Object.entries(item).reduce((acc, [key, value]) => {
                if (value) {
                  const valueDiv = value

                  if (key === 'name') {
                    acc[key] = (
                      <div style={{ whiteSpace: 'nowrap' }}>
                        <span
                          onClick={() =>
                            downloadReport(item.id, item.path_file)
                          }
                          style={{
                            color: 'blue',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                          }}
                        >
                          {String(valueDiv)}
                        </span>
                      </div>
                    ) as React.ReactNode
                  } else {
                    acc[key] = (
                      <div style={{ whiteSpace: 'nowrap' }}>
                        {String(valueDiv)}
                      </div>
                    ) as React.ReactNode
                  }
                }
                return acc
              }, {}),
              index,
            }
            return objectRow
          })
        }
        setTemplateColumn(res.columns)
        setTemplateRow(res.row)
        setResultItems(result?.items)
      } catch (error) {
        console.log(error)
        if (isAxiosError(error)) {
          toast({
            title: 'Error',
            description: error.response?.data?.errorMessage ?? error.message,
            type: 'error',
          })
        } else {
          toast({
            title: 'Error',
            description: `${error}`,
            type: 'error',
          })
        }
      } finally {
        setIsLoading(false)
      }
    } else {
      setTemplateColumn([])
      setTemplateRow([])
    }
  }

  const findProcessOrder = async () => {
    try {
      setIsLoading(true)
      if (testSelected && orderItem) {
        let orderItemSplit = orderItem.split('/')
        const pedidoItem = mapPedidoItem.find((p) => {
          const pedidoItemArray = p.label.split('/')
          return (
            pedidoItemArray[0] == orderItemSplit[0] &&
            pedidoItemArray[1] == orderItemSplit[1]
          )
        })

        if (pedidoItem?.value) {
          orderItemSplit = pedidoItem.value.split('/')
          const orderItemFind = {
            pedido: orderItemSplit[0],
            item: orderItemSplit[1],
          }
          setOrderItemFilter(orderItemFind)

          const result = await reportFilter({
            filterType: false,
            test: testSelected,
            filter: 'PROCESS_ORDER',
            start: moment(startDate)
              .startOf('day')
              .format('YYYY/MM/DD HH:mm:ss'),
            end: moment(endDate).startOf('day').format('YYYY/MM/DD HH:mm:ss'),
            project,
            site: siteCode,
            orderItem: pedidoItem.value as string,
            type: testSelected?.type,
            ...(getSampleType() !== undefined
              ? { sampleType: getSampleType() }
              : {}),
          })
          if (testSelected.type === 5) {
            setMapHeat(
              result?.list?.map((s: { corrida: string }, index: number) => ({
                key: index + 1,
                value: s.corrida,
                label: s.corrida,
              }))
            )
          } else {
            const listItems = result?.list?.map(
              (s: { lot_id: any; ordem_de_processo: any }, index: number) => ({
                key: index + 2,
                value: s.lot_id || s.ordem_de_processo || '',
                label: s.lot_id || s.ordem_de_processo,
              })
            )

            setMapProcessOrder(
              listItems
                ? addOptionAll(listItems, 1, t('application.selectAll'))
                : []
            )
            if (identificationApprovalFlow) {
              setProcessOrderItems(dataState.filter_header.orderProcess)
              setProcessOrderItemsApprovalFlow(undefined)
              search()
            }
          }
        }
      } else if (identificationApprovalFlow) {
        setIsLoading(false)
      }
    } catch (error: unknown) {
      if (isAxiosError(error)) {
        toast({
          title: 'Error',
          description: error.response?.data?.errorMessage ?? error.message,
          type: 'error',
        })
      }
    } finally {
      if (!identificationApprovalFlow) setIsLoading(false)
    }
  }

  const findOrderItem = async () => {
    try {
      setIsLoading(true)
      if (testSelected) {
        const result = await reportFilter({
          filterType: false,
          test: testSelected,
          filter: 'ORDER_ITEM',
          start: moment(startDate).startOf('day').format('YYYY/MM/DD HH:mm:ss'),
          end: moment(endDate).startOf('day').format('YYYY/MM/DD HH:mm:ss'),
          project,
          site: siteCode,
          orderItem: orderItemFilter,
          type: testSelected?.type,
        })
        if (testSelected.type === 5) {
          // heatItems = result.list;
          setMapPedidoItem(
            result?.list?.map(
              (
                s: { item: any; pedido: any; order_item: string },
                index: number
              ) => {
                if (s.order_item) {
                  return {
                    key: index + 1,
                    value: `${s.order_item}`,
                    label: `${s.order_item}`,
                  }
                }
                const pedido =
                  s.pedido && s.pedido.trim() !== '' ? s.pedido.trim() : ''
                const item =
                  s.item && s.item.trim() !== '' ? Number(s.item) : ''
                return {
                  key: index + 1,
                  value: `${s.pedido}/${s.item}`,
                  label: `${pedido}/${item}`,
                }
              }
            )
          )
        } else {
          const listItems = result?.list?.map(
            (s: { item: any; pedido: any; order_item: any }, index: number) => {
              if (s.order_item) {
                return {
                  key: index + 1,
                  value: `${s.order_item}`,
                  label: `${s.order_item}`,
                }
              }
              const pedido =
                s.pedido && s.pedido.trim() !== '' ? s.pedido.trim() : ''
              const item = s.item && s.item.trim() !== '' ? Number(s.item) : ''
              return {
                key: index + 1,
                value: `${s.pedido}/${s.item}`,
                label: `${pedido}/${item}`,
              }
            }
          )
          setMapPedidoItem(listItems)
          if (identificationApprovalFlow) {
            if (dataState.filter_header.orderItemChange) {
              setOrderItem(`${dataState.filter_header.orderItemChange.trim()}`)
            } else {
              setOrderItem(
                `${dataState.filter_header.pedido ? String(dataState.filter_header.pedido).trim().replace(/^0+/, '') : ''}/${dataState.filter_header.item ?? ''}`
              )
            }
          }
        }
      } else if (identificationApprovalFlow) {
        setIsLoading(false)
      }
    } catch (error: unknown) {
      if (isAxiosError(error)) {
        toast({
          title: 'Error',
          description: error.response?.data?.errorMessage ?? error.message,
          type: 'error',
        })
      }
    } finally {
      if (!identificationApprovalFlow) setIsLoading(false)
    }
  }

  const changeTest = (value: string) => {
    setTest(value)
    clearDate()
  }

  const clearResults = () => {
    setTemplateColumn([])
    setTemplateRow([])
    setResultItems([])
  }

  useEffect(() => {
    let clearFilter = true
    clearResults()
    if (startDate && endDate && testSelected) {
      if (moment(endDate).diff(moment(startDate), 'days') >= 90) {
        toast({
          title: 'Error',
          description: t('generateReport.filterSection.period_max'),
          type: 'error',
        })
      } else {
        findProjectsQp()
        clearFilter = false
      }
    }

    if (clearFilter) {
      clearPQ()
      clearProject()
      clearProcessOrder()
      clearHeat()
    }
  }, [startDate, endDate, testSelected])

  useEffect(() => {
    console.log('findProcessOrder')
    if (project) {
      findOrderItem()
    } else {
      clearPedidoItem()
    }
  }, [project])

  useEffect(() => {
    if (orderItem) {
      findProcessOrder()
    } else {
      clearPQ()
    }
  }, [orderItem])

  useEffect(() => {
    setTestSelected(
      TESTS.find((elem) => elem.name === test || elem.namePt === test)
    )
  }, [test])

  useEffect(() => {
    if (executeSearch) {
      search()
      setExecuteSearch(false)
    }
  }, [executeSearch])

  useEffect(() => {
    if (identificationApprovalFlow && originApprovalFlow) {
      search()
    }
  }, [pqLotItems])

  useEffect(() => {
    clearResults()
    if (originApprovalFlow && dataState?.docCode) {
      // originApprovalFlow = true
      // if (this.genarationReport) {
      // execHideLoading = false
      setIdentificationApprovalFlow(dataState.docCode)
      setSite(SITES.find((s) => s.code === dataState.site)?.name ?? '')
      setSiteCode(dataState.site)
      setTest(
        TESTS.find(
          (s) =>
            s.name === dataState.test_name || s.namePt === dataState.test_name
        )?.name ?? ''
      )

      // const start = moment(new Date('02-01-2023'), 'DD/MM/YYYY')
      // start.set({ hour: 0, minute: 0, second: 0 })

      // const end = moment(new Date('02-28-2023'))
      // end.set({ hour: 23, minute: 59, second: 59 })

      setStartDate(new Date(dataState.filter_header.startDate))
      setStartDateApprovalFlow(undefined)
      setEndDate(new Date(dataState.filter_header.endDate))
      setEndDateApprovalFlow(undefined)
      setProcessOrderItems(dataState.filter_header.orderProcess)

      // await this.findProjectsQp(start, end)
      // this.filterForm.patchValue({ project: filter_header.project })
      // await this.onChangeProject()

      // this.filterForm.patchValue({
      //   orderItem: `${filter_header.pedido}/${filter_header.item}`,
      // })
      // this.filterForm.patchValue({
      //   inspectorType: filter_header.inspectorType,
      // })
      // this.filterForm.patchValue({ sampleType: filter_header.sampleType })
      // await this.onChangeSampleType()

      // this.filterForm.patchValue({
      //   pqLot:
      //     typeof filter_header.pq === 'object'
      //       ? filter_header.pq
      //       : [filter_header.pq],
      // })

      // this.filterForm.patchValue({ orderProcess: filter_header.orderProcess })
      // setIdentificationApprovalFlowEmitter(state.docCode)
      // } else {
      //   this.filterForm.patchValue({ identification: state.docCode })
      //   this.searchDocumentEmitter.emit(true)
      // }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleMultiselectChange = (value: string[]) => {
    setMapProcessOrder((prevMap) => {
      setMultiselectInputValueProcessOrder((prevMultiselect) => {
        setSelectAllProcessOrder((prevSelectAll) => {
          if (value.includes(t('application.selectAll')) && !prevSelectAll) {
            prevMap[0].label = t('application.deselectAll')
            changeProcessOrder(prevMap.map((item) => item.value) as string[])
            return true
          }
          if (prevMap[0].label === t('application.deselectAll')) {
            prevMap[0].label = t('application.selectAll')
          }

          changeProcessOrder(
            prevSelectAll &&
              prevMultiselect.includes('NO_DEF') &&
              value.includes(t('application.deselectAll'))
              ? []
              : value
          )
          return false
        })
        return prevMultiselect
      })
      return prevMap
    })
  }

  useEffect(() => {
    setMultiselectInputValueProcessOrder(
      processOrderItemsApprovalFlow ?? processOrderItems ?? []
    )
  }, [processOrderItemsApprovalFlow, processOrderItems])

  return (
    <Section.Root
      header={
        <Section.Header
          title={t<string>('generateReport.filterSection.title')}
          isCollapsable
          actionButtons={
            <ButtonContainer width="8rem">
              <StyledButton onClick={() => search()}>
                <StyledTextButton>
                  <Icon name="SearchLine" color="white" />
                  {t<string>('generateReport.filterSection.search')}
                </StyledTextButton>
              </StyledButton>
            </ButtonContainer>
          }
        />
      }
    >
      <Row>
        <SearchBarContainer>
          <StyledInputLabel>
            {t('generateReport.filterSection.identification')}
          </StyledInputLabel>
          <TextFieldInput
            fontSize="text-md"
            name="identification"
            onChange={(event) => setIdentification(event?.target?.value)}
            placeholder={t('', t('searchReport.filterSection.identification'))}
            width="100%"
            value={identification}
          />
        </SearchBarContainer>
        <SearchBarContainer>
          <StyledInputLabel>
            {t('generateReport.filterSection.idNumeric')}
          </StyledInputLabel>
          <TextFieldInput
            fontSize="text-md"
            name="idNumeric"
            onChange={(event) => setIdNumeric(event?.target?.value)}
            placeholder={t('', t('searchReport.filterSection.idNumeric'))}
            width="100%"
            value={idNumeric}
          />
        </SearchBarContainer>
        <SearchBarContainer>
          <StyledInputLabel>
            {t('generateReport.filterSection.site')}
          </StyledInputLabel>
          <SearchBar
            type="text"
            data={mappedSites}
            placeholder={t('generateReport.filterSection.site')}
            iconColor="neutral-color-60"
            onChange={(value) => {
              setSite(value)
              clearTest(value)
            }}
            inputValue={site}
          />
        </SearchBarContainer>
        <SearchBarContainer>
          <StyledInputLabel>
            {t('generateReport.filterSection.test')}
          </StyledInputLabel>
          <SearchBar
            type="text"
            data={mappedTestsFilter}
            placeholder={t('generateReport.filterSection.test')}
            iconColor="neutral-color-60"
            onChange={(value) => {
              changeTest(value)
            }}
            inputValue={test}
          />
        </SearchBarContainer>
        <SearchBarContainer ref={rowFocus}>
          <DatePicker.Root>
            <DatePicker.Trigger
              label={t<string>('generateReport.filterSection.startDate')}
              value={
                startDateApprovalFlow
                  ? new Date(startDateApprovalFlow)
                  : startDate
                    ? new Date(startDate)
                    : undefined
              }
            />
            <DatePicker.SingleDayPicker
              onDaySelect={({ selected }) => selected && setStartDate(selected)}
              closeOnSelect
            />
          </DatePicker.Root>
        </SearchBarContainer>
        <SearchBarContainer>
          <DatePicker.Root>
            <DatePicker.Trigger
              label={t<string>('generateReport.filterSection.endDate')}
              value={
                endDateApprovalFlow
                  ? new Date(endDateApprovalFlow)
                  : endDate
                    ? new Date(endDate)
                    : undefined
              }
            />
            <DatePicker.SingleDayPicker
              onDaySelect={({ selected }) =>
                selected && setEndDate(new Date(selected))
              }
              closeOnSelect
            />
          </DatePicker.Root>
        </SearchBarContainer>
        {testSelected?.type !== 4 && testSelected?.name !== 'mpi' && (
          <SearchBarContainer>
            <StyledInputLabel>
              {t('generateReport.filterSection.project')}
            </StyledInputLabel>
            <SearchBar
              type="text"
              data={mapProjects}
              placeholder={t('generateReport.filterSection.project')}
              iconColor="neutral-color-60"
              onChange={(value) => {
                setLabelProject(value)
                setProject(value ? (value !== '***' ? value : 'NO_DEF') : '')
              }}
              inputValue={labelProject}
            />
          </SearchBarContainer>
        )}
        {testSelected?.type !== 4 && testSelected?.name !== 'mpi' && (
          <SearchBarContainer>
            <StyledInputLabel>
              {t('generateReport.filterSection.orderItem')}
            </StyledInputLabel>
            <SearchBar
              type="text"
              data={mapPedidoItem}
              placeholder={t('generateReport.filterSection.orderItem')}
              iconColor="neutral-color-60"
              onChange={(value) => setOrderItem(value)}
              inputValue={orderItem}
            />
          </SearchBarContainer>
        )}
        {testSelected?.type !== 4 && testSelected?.name !== 'mpi' && (
          <SearchBarContainer>
            <StyledInputLabel>
              {t('generateReport.filterSection.type')}
            </StyledInputLabel>
            <SearchBar
              type="text"
              data={mapInsterpectorType}
              placeholder={t('generateReport.filterSection.type')}
              iconColor="neutral-color-60"
              onMultiselectChange={(value) => changeType(value)}
              inputValue=""
              multiselect
              multiselectInputValue={typeItems ?? []}
            />
          </SearchBarContainer>
        )}
        {testSelected?.type === 4 && testSelected?.name !== 'mpi' && (
          <SearchBarContainer>
            <StyledInputLabel>
              {t('generateReport.filterSection.pqLot')}
            </StyledInputLabel>
            <SearchBar
              type="text"
              data={mapPqLot}
              placeholder={t('generateReport.filterSection.pqLot')}
              iconColor="neutral-color-60"
              onMultiselectChange={(value) => changePQ(value)}
              inputValue=""
              multiselect
              multiselectInputValue={pqLotItems ?? []}
            />
          </SearchBarContainer>
        )}
        {testSelected?.type !== 5 &&
          testSelected?.type !== 4 &&
          testSelected?.name !== 'mpi' && (
            <SearchBarContainer>
              <StyledInputLabel>
                {t('generateReport.filterSection.processOrder')}
              </StyledInputLabel>
              <SearchBar
                type="text"
                data={mapProcessOrder}
                placeholder={t('generateReport.filterSection.processOrder')}
                iconColor="neutral-color-60"
                onMultiselectChange={handleMultiselectChange}
                inputValue=""
                multiselectInputValue={multiselectInputValueProcessOrder}
                multiselect
              />
            </SearchBarContainer>
          )}
        {testSelected?.type === 5 && testSelected?.name !== 'mpi' && (
          <SearchBarContainer>
            <StyledInputLabel>
              {t('generateReport.filterSection.heat')}
            </StyledInputLabel>
            <SearchBar
              type="text"
              data={mapHeat}
              placeholder={t('generateReport.filterSection.heat')}
              iconColor="neutral-color-60"
              onMultiselectChange={(value) => changeHeat(value)}
              inputValue=""
              multiselect
            />
          </SearchBarContainer>
        )}
        <CheckboxContainer>
          <StyledInputLabel>
            {t('searchReport.filterSection.active')}
          </StyledInputLabel>
          <Checkbox
            key="checkbox-"
            label={t('')}
            checked={active}
            withLabel
            onCheckedChange={() => setActive(!active)}
          />
        </CheckboxContainer>

        <CheckboxContainer>
          <StyledInputLabel>
            {t('searchReport.filterSection.inactive')}
          </StyledInputLabel>
          <Checkbox
            key="checkbox-"
            label={t('')}
            checked={inactive}
            withLabel
            onCheckedChange={() => setInactive(!inactive)}
          />
        </CheckboxContainer>
      </Row>
    </Section.Root>
  )
}

export default FilterSection
